<template>
  <div class="change-transaction-category-popup">
    <colored-popup :class="categoryToVariant[selectedCategory.cashflowCategory]" :close-action="close">

      <template v-slot:top-content>
        <div class="expense-title">
          <span class="name">{{ title }}</span>
        </div>
        <transaction-details :transaction="transaction" />
      </template>

      <template v-slot:bottom-content>
        <div class="prompt">להוסיף עוד משהו?</div>
        <text-input class='text-input'
                    :value="comment"
                    :autofocus="true"
                    :placeholder="'כאן אפשר להוסיף הערה'"
                    :on-input="onInput"/>
        <riseup-button :action="onSave"
                       :variant="'primary'"
                       :size="'slim'"
                       :title="isNewComment ? 'הוספת הערה' : 'עריכת הערה'"
                       :disabled="isSaveDisabled"/>
      </template>

      <template v-slot:footer v-if="!isNewComment">
        <div class="cancel" v-on:click="eraseComment">
          <span class="delete-text">מחיקת הערה</span>
        </div>
      </template>

    </colored-popup>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import cashflowViewConsts from '@/constants/cashflow-view';
import TransactionDetails from './TransactionDetails.vue';
import Segment from '../../../../../../../../../../Segment';

export default {
  name: 'AddTransactionComment',
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
    TextInput: BaseUI.TextInput,
    TransactionDetails,
    RiseupButton: BaseUI.RiseupButton,
  },
  created() {
    this.sendSegmentEvent('AddTransactionComment_Shown');
    this.comment = this.transaction.customerComment || '';
  },
  data() {
    return {
      comment: '',
    };
  },
  computed: {
    ...mapState('editTransaction', ['transaction']),
    ...mapGetters('editTransaction', ['selectedCategory', 'categoryToVariant', 'originalCategory', 'incomeOrExpense']),
    isSaveDisabled() {
      return this.comment === this.transaction.customerComment;
    },
    isNewComment() {
      return !this.transaction.customerComment;
    },
    isSaving() {
      return this.transaction.isSaving;
    },
    title() {
      if (this.isSaving) {
        return cashflowViewConsts.SAVING_LABEL;
      }
      return `${this.incomeOrExpense} ${this.selectedCategory.label}`;
    },
  },
  methods: {
    ...mapActions('editCashflow', ['setComment']),
    close() {
      this.sendSegmentEvent('AddTransactionComment_CloseClicked');
      this.$emit('close');
    },
    sendSegmentEvent(eventName) {
      Segment.trackUserInteraction(eventName, {
        businessName: this.transaction.businessName,
        originalCategory: this.transaction.expense,
        transactionId: this.transaction.transactionId,
      });
    },
    async onSave() {
      this.sendSegmentEvent('AddTransactionComment_SaveClicked');
      await this.setComment({ transactionId: this.transaction.transactionId, comment: this.comment });
      this.$emit('close');
    },
    onInput(comment) {
      this.comment = comment;
    },
    async eraseComment() {
      this.sendSegmentEvent('AddTransactionComment_DeleteClicked');
      await this.setComment({ transactionId: this.transaction.transactionId, comment: '' });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
  @import '~base-ui/src/scss/riseup-colors';

  .change-transaction-category-popup {
    text-align: right;

    .colored-top {
      color: $riseup_white;

      .expense-title {
        margin-bottom: 16px;
        line-height: 11px;

        .name, .dot{
          font-weight: bold;
        }
      }
    }

    .prompt {
      line-height: 13px;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .text-input {
      margin-bottom: 40px;
    }

    .riseup-button {
      width: 100%;
    }

    .cancel {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      .delete-text {
        color: $riseup_black;
        font-size: 18px;
      }
    }
  }

</style>
